export default __webpack_public_path__ + "static/media/the-strength@2x.265df712.png";